import i18nFactory from '@yandex-int/i18n';
import moment from 'moment';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { CustomPeriodBudgetValue } from '../../typings/budget';
import { MoneyText } from '../MoneyText/MoneyText';

import './GridCampaignCustomPeriodBudgetCell.css';
import * as keyset from './GridCampaignCustomPeriodBudgetCell.i18n';

const i18n = i18nFactory(keyset);
const block = 'grid-campaign-custom-period-budget-cell';

export interface GridCampaignCustomPeriodBudgetCellProps {
    value: CustomPeriodBudgetValue;
    isCompactViewEnabled: boolean;
}

export class GridCampaignCustomPeriodBudgetCell extends React.PureComponent<GridCampaignCustomPeriodBudgetCellProps> {
    render(): React.ReactNode {
        const {
                value: { sum, start, finish },
                isCompactViewEnabled
            } = this.props,
            from = moment(start, 'YYYY-MM-DD').format('L'),
            to = moment(finish, 'YYYY-MM-DD').format('L');

        return (
            <div
                className={Bem.cls({
                    block: block,
                    mods: { compact: isCompactViewEnabled }
                })}
            >
                <p className={Bem.cls(block, 'value')}>
                    <MoneyText num={sum} fractionalPartLength={2} />
                </p>

                <p className={Bem.cls(block, 'hint')}>{i18n('period-from-to', { from, to })}</p>
            </div>
        );
    }
}
